import React, { memo } from 'react';
import AdBlock from './AdBlock';
import { TransactionProvider } from '../contexts/TransactionContext';
import { ParsedTransaction } from '../../../../../typings/transaction';

import S from './style/OrderCardResponsive';

interface OrderCardResponsiveProps {
  children?: React.ReactNode | React.ReactNode[];
  active?: boolean;
  transaction: ParsedTransaction;
  packageDeliveryInfoUrl: string;
  packageDeliveryBuyerManualUrl: string;
  packageDeliverySellerManualUrl: string;
  onTitleClick: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  showOrderSafeDealPackageDeliveredDescr: boolean;
  goToReturns?: () => void;
}

const OrderCardResponsive: React.FC<OrderCardResponsiveProps> = ({
  children = null,
  active,
  transaction,
  onTitleClick,
  packageDeliveryInfoUrl,
  packageDeliveryBuyerManualUrl,
  packageDeliverySellerManualUrl,
  showOrderSafeDealPackageDeliveredDescr,
  goToReturns,
}) => (
  <TransactionProvider value={transaction}>
    <S.OrderCardContainer data-cy="order-card">
      <S.OrderBlock>
        <AdBlock
          active={active}
          onTitleClick={onTitleClick}
          packageDeliveryInfoUrl={packageDeliveryInfoUrl}
          packageDeliveryBuyerManualUrl={packageDeliveryBuyerManualUrl}
          packageDeliverySellerManualUrl={packageDeliverySellerManualUrl}
          showOrderSafeDealPackageDeliveredDescr={showOrderSafeDealPackageDeliveredDescr}
          goToReturns={goToReturns}
        />
      </S.OrderBlock>
      <S.ActionsBlock>{children}</S.ActionsBlock>
    </S.OrderCardContainer>
  </TransactionProvider>
);

export default memo(OrderCardResponsive);
